import { centsToEur } from '~/@lib/utils/money.utils'
import { ProgressActivityIcon } from '~/@mid_ui/icons/ProgressActivityIcon'
import { GraphIcon } from '~/@mid_ui/icons/GraphIcon'
import { RequestQuoteIcon } from '~/@mid_ui/icons/RequestQuoteIcon'
import { TollIcon } from '~/@mid_ui/icons/TollIcon'
import { WalletIcon } from '~/@mid_ui/icons/WalletIcon'
import { CurrencyFormatter } from '~/@mid_ui/currency-formatter/CurrencyFormatter'
import { PageContainer } from '~/@mid_ui/page-container/PageContainer'
import { tooltipByType } from './tooltipByType'
import { useFinancialOverviewQuery } from './useFinancialOverviewQuery'

const commonClassName =
  'flex flex-col gap-10 min-h-[140px] lg:min-h-0 justify-between h-full'

function WalletAggregates() {
  const { data: aggregates } = useFinancialOverviewQuery()
  if (aggregates == null)
    return <PageContainer>Zostatky sa nenašli</PageContainer>

  return (
    <div className="grid grid-cols-2 lg:grid-cols-2 lg:grid-rows-[auto_auto_auto] gap-px bg-border md:border border-b border-border">
      <div
        className={`${commonClassName} p-5 bg-background col-span-2 lg:col-span-1 lg:col-start-2 lg:row-start-1 lg:row-span-3 order-1 lg:order-0`}>
        <div className="flex items-center gap-2">
          <ProgressActivityIcon className="text-accent" />
          <p className="text-lg md:text-2xl font-semibold">Očakávané výnosy</p>
          {tooltipByType.expectedFutureRevenue}
        </div>
        <CurrencyFormatter
          className="text-4xl md:text-7xl font-semibold text-accent"
          decimalClassName="text-2xl md:text-5xl font-semibold"
          value={centsToEur(aggregates.expectedFutureRevenue)}
        />
      </div>

      <div
        className={`${commonClassName} p-5 bg-background col-span-1 order-2 lg:order-0`}>
        <div className="flex items-center gap-2">
          <GraphIcon className="text-accent shrink-0" />
          <p className="text-sm md:text-2xl font-semibold">Hodnota účtu</p>
          {tooltipByType.accountValue}
        </div>
        <CurrencyFormatter
          className="text-xl md:text-7xl font-semibold"
          decimalClassName="text-base md:text-5xl"
          value={centsToEur(aggregates.totalAccountValue)}
        />
      </div>

      <div
        className={`${commonClassName} p-5 bg-background col-span-1 order-3 lg:order-0`}>
        <div className="flex items-center gap-2">
          <WalletIcon className="text-accent shrink-0" />
          <p className="text-sm md:text-base font-semibold">Moja peňaženka</p>
          {tooltipByType.disponibleFunds}
        </div>
        <CurrencyFormatter
          className="text-xl md:text-3xl font-semibold"
          decimalClassName="text-base md:text-2xl font-semibold"
          value={centsToEur(aggregates.disponibleFunds)}
        />
      </div>

      <div className="col-span-2 lg:col-span-1 order-4 lg:order-0 lg:col-start-1 lg:row-start-3 grid grid-cols-2 gap-px">
        <div className={`${commonClassName} p-5 bg-background`}>
          <div className="flex items-center gap-2">
            <RequestQuoteIcon className="text-accent shrink-0" />
            <p className="text-sm md:text-base font-semibold">
              Rezervované prostriedky
            </p>
            {tooltipByType.reservedFunds}
          </div>
          <CurrencyFormatter
            value={centsToEur(aggregates.totalBlockedFunds)}
            className="text-xl md:text-3xl font-semibold"
            decimalClassName="text-base md:text-2xl font-semibold"
          />
        </div>
        <div className={`${commonClassName} p-5 bg-background`}>
          <div className="flex items-center gap-2">
            <TollIcon className="text-accent shrink-0" />
            <p className="text-sm md:text-base font-semibold">
              Investované prostriedky
            </p>
            {tooltipByType.investedFunds}
          </div>
          <CurrencyFormatter
            className="text-xl md:text-3xl font-semibold"
            decimalClassName="text-base md:text-2xl font-semibold"
            value={centsToEur(aggregates.remainingInvestedFunds)}
          />
        </div>
      </div>
    </div>
  )
}

export { WalletAggregates }
